export default {
    currentStep: 0,
    isShowInvitationCode: false, //是否展示邀请码填写
    form: {
        userType: "",
        invitationCode: "", //邀请码
        companyLicence:{
            lincenceUrl:"",
            code:"",
            name:"",
            companyNature:"",
            ownerName:"",
            address:"",
            scope:"",
            beginDate:"",
            endDate:"",
            province:"",
            city:"",
            district:"",
            foreverFlag: false,
            doorFileUrl: "" //门头门店照片
        },
        userLicence:{
            licenceUrl: "",
            licenceBackUrl: "",
            name: "",
            type: "1", //身份证
            code: "",
            beginDate: "",
            endDate: "",
            foreverFlag: false
        },
        qualificationInfo: {
            levelOneId:"",
            levelTwoId: "",
            levelThreeId: "",
            departmentId: ""
        }
    },
    personalInfo: null
}


// WEBPACK FOOTER //
// ./src/store/register/state.js